import { useEffect, useState } from "react";
import ajaxProduct from "../../util/remote/ajaxProduct";
import SystemModal from "../../Components/Common/SystemModal";
import Loader from "../../Components/Common/Loader";
import useStateCallback from "../../util/customHooks/useStateCallback";
import { Link } from "react-router-dom";
import ListInventoryForClient from "./ListInventoryForClient";
const ListInventoryForClientProductPerStore = (props) => {
  const [product, setProduct] = useState(props.product);
  const [productName, setProductName] = useState(props.productName);
  const [loading, setLoading] = useState(false);
  const [client, setClient] = useState(props.client);
  const [clientName, setClientName] = useState(props.clientName);
  const [inventoryList, setInventoryList] = useState(false);
  const getInventory = async () => {
    setLoading(true);
    let data = {
      product_id: product,
      client: client,
      storeID: props.storeID,
    };
    const server_response =
      await ajaxProduct.list_product_stock_sum_per_store(data);
    setLoading(false);
    if (server_response.status === "OK") {
      setInventoryList(server_response.details);
    }
  };
  useEffect(() => {
    getInventory(product, client);
  }, [product, client]);

  const [modal, SetModal] = useStateCallback(false);
  const handleModal = (e, item) => {
    SetModal(false, () =>
      SetModal(
        <ListInventoryForClient
          product={product}
          productName={productName}
          clientName={clientName}
          client={client ?? ""}
          storeID={item.store_id ?? ""}
          isOpen={true}
        />,
      ),
    );
  };
  const RenderFooter = (controls) => {
    if (loading) {
      return <Loader />;
    } else {
      return (
        <>
          <button
            className="btn ripple btn-dark"
            type="button"
            onClick={controls.close}
          >
            Close
          </button>
        </>
      );
    }
  };
  return (
    <SystemModal
      title={productName + " stock flow in store"}
      id="model-list_transactions"
      size="md"
      footer={RenderFooter}
    >
      {modal}
      <div class="d-lg-flex">
        <h2 class="card-title mb-1">Product: {productName}</h2>
        <div class="ml-auto">
          <p class="mb-1">
            <span class="font-weight-bold">Client :</span> {clientName}
          </p>
        </div>
      </div>
      <hr class="mg-b-40" />
      <div className="table-responsive">
        {loading && <Loader />}
        <table className="table table-striped table-bordered">
          <thead>
            <th>Store Name</th>
            <th>Quantity In</th>
            <th>Quantity Out</th>
            <th>Balance</th>
            <th>View Flow</th>
          </thead>
          <tbody>
            {!Array.isArray(inventoryList) && (
              <tr>No inventory transactions yet</tr>
            )}
            {Array.isArray(inventoryList) &&
              inventoryList.map((item, index) => (
                <tr key={index}>
                  <td>{item.store_name}</td>
                  <td>{item.qty_in.qty_in_c}</td>
                  <td>{item.qty_out.qty_out_c}</td>
                  <td>{item.balance.balance_c}</td>
                  <td>
                    <Link
                      className="btn btn-sm btn-info mr-2"
                      href="#"
                      onClick={(e) => handleModal(e, item)}
                    >
                      View Ins and Outs
                    </Link>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </SystemModal>
  );
};
export default ListInventoryForClientProductPerStore;
